<template>
  <div>
        <div>
            <PadorConfirm v-if="login == 1" />
            <LoginFloatConfirm v-else />
        </div>
  </div>

</template>

<script>
import PadorConfirm from './Default/confirm_password'
import LoginFloatConfirm from './LoginFloat/confirm_password'
import { UserServicesConfirmUserTest } from "@services/UserServices";
export default {
    components: {
        PadorConfirm,
        LoginFloatConfirm
    },
    data(){
      return{
        login: 1,
        domain: null
      }
    },
    methods:{
      confirmAccountTest(key){
        this.$store.commit("loadings/setStateLoadingTemplate", true);

        let body = {
          activateToken: key
        }
        return UserServicesConfirmUserTest(body)
          .then(response => {

          })
          .catch(error => {
                this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

              throw new Error("error to do create", error);
          })
          .finally(() => {
              this.$store.commit("loadings/setStateLoadingTemplate", false);
          });
      }
    },
    mounted(){
      this.domain = JSON.parse(localStorage.getItem('@datadrive:domain'))
      this.login = this.domain.entityLayoutID

      if(!this.domain){
        location.reload();
      }
      const key = this.$helpers.getParameterByName('key');

      this.confirmAccountTest(key);

    }
}
</script>
